<template>
  <div class="product-info__buttons">
    <button v-show="showAddToWishList"
            type="button"
            class="btn btn-accent-1"
            @click="addToWishlistClicked">
      Add to wish list
    </button>

    <button v-show="showPriceOnApplication"
            type="button"
            class="btn btn-accent-1"
            @click="priceOnApplicationClicked">
      Price on application
    </button>

    <button v-show="showRegisterInterest"
            type="button"
            class="btn btn-accent-1"
            @click="addRegisterInterestClicked">
      Register interest
    </button>
  </div>
</template>

<script>
export default {
  name: "ProductPricingButtons",
  props: {
    showAddToWishList: {
      type: Boolean,
      default: false
    },
    showPriceOnApplication: {
      type: Boolean,
      default: true
    },
    showRegisterInterest: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    priceOnApplicationClicked () {
      this.$root.$emit( "priceOnApplicationClicked" );
    },
    addToWishlistClicked () {
      this.$root.$emit( "addToWishlistClicked" );
    },
    addRegisterInterestClicked () {
      this.$root.$emit( "addRegisterInterestClicked" );
    }
  }

};
</script>

<style>

</style>
